// extracted by mini-css-extract-plugin
export default {"inputsContainer":"BaseForm_inputsContainer__dc3z+","inputHalfWidth":"BaseForm_inputHalfWidth__WILVT","formWrapper":"BaseForm_formWrapper__5jBh3"};